export default function () {
    /* 表格列头 */
    return [
        { label: "", type: "selection", width: 55 },
        { label: "序号", type: "index", width: 60 },
        { label: "项目名称", prop: "project_name", width: 140 },
        { label: "唯一编码", prop: "code", width: 140 },
        { label: "积分", prop: "point", width: 100 },
        // { label: "二维码链接", prop: "url_link", minWidth: 360 },
        { label: "创建时间", prop: "create_time", width: 180 },
        { label: "领取人openid", prop: "user_openid", minWidth: 200 },
        { label: "领取人手机号", prop: "user_phone", width: 140 },
        { label: "领取时间", prop: "exchange_time", width: 180 },
        {
            label: "操作",
            prop: "operation",
            width: 160,
            slots: "operation",
            fixed: "right",
        },
    ];
}
